import { Directive } from '@angular/core';
import { BrnSheetTitle } from '@spartan-ng/brain/sheet';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
    host: { 'data-slot': 'sheet-title' },
    hostDirectives: [BrnSheetTitle],
    selector: '[hlmSheetTitle]',
})
export class HlmSheetTitle {
    constructor() {
        classes(() => 'text-foreground font-medium');
    }
}
